export default {
  drawerTitle: {
    id: 'product_page_refurb_process_drawer_title',
    defaultMessage: 'Refurbishment process',
  },
  step1Title: {
    id: 'product_page_refurb_process_drawer_step1_title',
    defaultMessage: 'Assessment',
  },
  step1Content: {
    id: 'product_page_refurb_process_drawer_step1_content',
    defaultMessage:
      'The device is inspected for cosmetic damage, then the refurbisher determines the grade.',
  },
  step2Title: {
    id: 'product_page_refurb_process_drawer_step2_title',
    defaultMessage: 'Diagnostics',
  },
  step2Content: {
    id: 'product_page_refurb_process_drawer_step2_content',
    defaultMessage:
      'Automated tests are run on every hardware component (cameras, sensors, battery, connectivity, biometrics, etc) and the device is securely wiped.',
  },
  step3Title: {
    id: 'product_page_refurb_process_drawer_step3_title',
    defaultMessage: 'Battery check',
  },
  step3Content: {
    id: 'product_page_refurb_process_drawer_step3_content',
    defaultMessage:
      'Anything under 80% battery capacity gets a fresh replacement, so you always get a high performing battery.',
  },
  step4Title: {
    id: 'product_page_refurb_process_drawer_step4_title',
    defaultMessage: 'Cleaning and repair',
  },
  step4Content: {
    id: 'product_page_refurb_process_drawer_step4_content',
    defaultMessage:
      'The technician will replace or repair anything flagged in diagnostics, while specialized machines handle glass separation, laser removal, polishing, and soldering. The device is then fully reassembled.',
  },
  step5Title: {
    id: 'product_page_refurb_process_drawer_step5_title',
    defaultMessage: 'Final tests and certification',
  },
  step5Content: {
    id: 'product_page_refurb_process_drawer_step5_content',
    defaultMessage:
      'The device undergoes another vigorous quality inspection check. Finally, it gets checked by a technician who assigns the official cosmetic grade and certifies the device for sale.',
  },
}
